import { useState, useRef, useEffect } from 'react';

type ObserverOptions = IntersectionObserverInit;
type ObserverReturn = [
  IntersectionObserverEntry | null,
  React.RefObject<Element>,
];

const useObserver = (options: ObserverOptions): ObserverReturn => {
  const [observerEntry, setEntry] = useState<IntersectionObserverEntry | null>(
    null,
  );
  const elRef = useRef<Element | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => setEntry(entries[0]),
      options,
    );
    if (elRef.current) {
      observer.observe(elRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return [observerEntry, elRef];
};

export default useObserver;
